@if (hasLookupLife) {
  <div class="form-control-plaintext">{{ model | number }} years</div>
} @else {
  @if (!lifeValues) {
    <div class="input-group">
      <input
        type="number"
        class="form-control text-end"
        [class.is-invalid]="
          form.controls.life.touched && form.controls.life.invalid
        "
        [class.is-valid]="
          form.controls.life.touched && form.controls.life.valid
        "
        step="1"
        [attr.aria-label]="
          'Effective Life (' + (isUnitsOfUse ? 'units' : 'years') + ')'
        "
        [ngModel]="model"
        [disabled]="isDisabled"
        (ngModelChange)="onChange($event)"
        (blur)="onBlur()"
      />
      <div class="input-group-text rounded-end">
        @if (isUnitsOfUse) {
          <span> units </span>
        }
        @if (!isUnitsOfUse) {
          <span> years </span>
        }
      </div>
      <div *invalidMessageFor="'required'" class="invalid-feedback">
        Effective Life is required
      </div>
      <div *invalidMessageFor="'min' as error" class="invalid-feedback">
        Effective Life must be greater than zero
      </div>
      <div
        *invalidMessageFor="'remainingLife' as error"
        class="invalid-feedback"
      >
        Remaining Life must be greater than zero
      </div>
    </div>
  } @else if (lifeValues.length === 1) {
    <div class="form-control-plaintext">{{ lifeValues[0] | number }} years</div>
  } @else {
    <select
      class="form-select"
      [class.is-invalid]="
        form.controls.life.touched && form.controls.life.invalid
      "
      [class.is-valid]="form.controls.life.touched && form.controls.life.valid"
      aria-label="Effective Life (years)"
      [ngModel]="model"
      [disabled]="isDisabled"
      (ngModelChange)="onChange($event)"
      (blur)="onBlur()"
    >
      @for (item of lifeValues; track item) {
        <option [ngValue]="item">
          {{ item | number }}
        </option>
      }
    </select>
    <div *invalidMessageFor="'required'" class="invalid-feedback">
      Effective Life is required
    </div>
    <div *invalidMessageFor="'remainingLife'" class="invalid-feedback">
      Remaining Life must be greater than zero
    </div>
  }
}
